module.exports = __webpack_public_path__ + "img/investment.11e8731c.png";